import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import createModel, { Union } from "@/__main__/data-model.mjs";
import { FORTNITE_QUEUES_BE } from "@/game-fortnite/constants/queues.mjs";
import { PlayerMatch } from "@/game-fortnite/models/match-player.mjs";

export const Match = {
  gameId: String,
  mode: Union(Object.values(FORTNITE_QUEUES_BE)),
  playerMatches: [PlayerMatch],
  seasonId: String,
  startedAt: Date,
  isZeroBuild: Boolean,
  isRanked: Boolean,
} satisfies ModelDefinition;

const MatchQueryValidator = createModel({
  data: {
    match: Match,
  },
}).transform(Match, (response) => response.data.match);

export type MatchQuery = FromModel<typeof Match>;

export default MatchQueryValidator;
